import { Component } from '@angular/core';

@Component({
  selector: 'app-in-footer',
  templateUrl: './in-footer.component.html',
  styleUrls: ['./in-footer.component.css']
})
export class InFooterComponent {

}
